// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".VehicleScreen .VehicleContainer{padding:20px}.DashboardMainChart{display:flex;flex-direction:column;width:100%;max-width:100%}.DashboardMainChartTitle{display:flex;align-items:center;margin:10px 0}.DashboardMainChartTitle span{color:#333;font-size:20px}.DashboardMainChartTitle em{font-size:28px;margin-right:10px}.Dashboard_Data_Charts{height:500px;position:relative;margin-top:20px}.Dashboard_Data_Charts.__marginTop{margin-top:20px}.Dashboard_Generic_Chart{height:500px;width:100%;position:absolute;left:0;top:0;opacity:0;transition:.2s}.Dashboard_Generic_Chart.__active{opacity:1;z-index:1}", ""]);
// Exports
exports.locals = {
	"primaryColor": "#85ba17",
	"lightPrimary": "#32cd32",
	"secondaryColor": "#22a8dd",
	"lightSecondary": "#b8e4f0"
};
module.exports = exports;
